import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import LandingPage from './pages/LandingPage';
import RepairGadgetPage from './pages/RepairGadgetPage';
import DefectsPage from './pages/DefectsPage';
import BrandModelPage from './pages/BrandModelPage';
import Singup from './pages/Singup';
import BookingFeePage from './components/bookingFee/Booking';
import AddressPage from './pages/AddressPage';
import BookingConfirmPage from './pages/BookingConfirmPage';
import CareFlowLandingPage from "../src/care-flow/pages/LandingPage/LandingPage";
import DeviceSelection from "../src/care-flow/pages/SelectDevice/SelectDevice";
import Signup from "./care-flow/pages/Signup/Signup";
import EstimatedPrice from "./care-flow/pages/EstimatedPrice/EstimatedPrice";
import SessionStorageClearer from './components/SessionStorageClearer';
import Address from './care-flow/pages/Address/Address';
import CareplanConfirmed from './care-flow/pages/CareplanConfirmed/CareplanConfirmed';
import ContactUs from './components/contact/ContactUs'; // Ensure this path is correct


const App = () => {
  return (
    <BrowserRouter>
      <SessionStorageClearer />
      <Routes>
        <Route path="/" element={<><Helmet><title>Gadgets Reborn - Home</title></Helmet><LandingPage /></>} />
        <Route path="/repair-gadget" element={<><Helmet><title>Gadgets Reborn - Get Your Device Repaired</title></Helmet><RepairGadgetPage /></>} />
        <Route path="/defects" element={<><Helmet><title>Gadgets Reborn - Select Defects</title></Helmet><DefectsPage /></>} />
        <Route path="/repair/mobile" element={<><Helmet><title>Gadgets Reborn - Select Defects</title></Helmet><DefectsPage /></>} />
        <Route path="/repair/tablet" element={<><Helmet><title>Gadgets Reborn - Select Defects</title></Helmet><DefectsPage /></>} />
        <Route path="/category" element={<><Helmet><title>Gadgets Reborn - Select Category</title></Helmet><BrandModelPage /></>} />
        <Route path="/signup" element={<><Helmet><title>Gadgets Reborn - Sign Up</title></Helmet><Singup /></>} />
        <Route path="/booking-fee" element={<><Helmet><title>Gadgets Reborn - Booking Fee</title></Helmet><BookingFeePage /></>} />
        <Route path="/address" element={<><Helmet><title>Gadgets Reborn - Address</title></Helmet><AddressPage /></>} />
        <Route path="/booking-confirmed" element={<><Helmet><title>Gadgets Reborn - Booking Confirmed</title></Helmet><BookingConfirmPage /></>} />

        {/* Care flow Routes */}
        <Route path="/care-flow" element={<><Helmet><title>Gadgets Reborn - Get Your Device Protected</title></Helmet><CareFlowLandingPage /></>} />
        <Route path="/care-flow/select-device" element={<><Helmet><title>Gadgets Reborn - Care Flow - Select Device</title></Helmet><DeviceSelection /></>} />
        <Route path="/care-flow/sign-up" element={<><Helmet><title>Gadgets Reborn - Care Flow - Sign Up</title></Helmet><Signup /></>} />
        <Route path="/care-flow/estimated-price" element={<><Helmet><title>Gadgets Reborn - Care Flow - Estimated Price</title></Helmet><EstimatedPrice /></>} />
        <Route path="/care-flow/address" element={<><Helmet><title>Gadgets Reborn - Care Flow - Select Address</title></Helmet><Address /></>} />
        <Route path="/care-flow/booking-confirmed" element={<><Helmet><title>Gadgets Reborn - Care Flow - Select Address</title></Helmet>< CareplanConfirmed /></>} />
        {/* { other pages} */}
        {/* <Route path="/contact-us" element={<ContactUs />} /> */}
        <Route path="/contact-us" element={<><Helmet><title>Gadgets Reborn - Contact Us</title></Helmet><ContactUs /></>} />


      </Routes>
    </BrowserRouter>
  )
}

export default App;
